import React from 'react';
import { Icon, IconProps } from './Icon';

export const TrendingDownIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      viewBox="0 0 22 12"
      width="22"
      height="12"
      strokeWidth={0.5}
      {...props}
    >
      <path
        d="M0.719727 0.219727C1.00854 -0.0690836 1.47383 -0.0727502 1.76758 0.208008L1.78027 0.219727L7.46973 5.90918C7.61037 6.04976 7.80114 6.12891 8 6.12891C8.19252 6.12891 8.37734 6.05421 8.5166 5.92188L8.53027 5.90918L10.9092 3.53027C11.3311 3.10839 11.9033 2.87109 12.5 2.87109C13.0874 2.87109 13.6514 3.10122 14.0713 3.51074L20 9.43945V6C20 5.59072 20.3279 5.25786 20.7354 5.25H20.75C21.1593 5.25 21.4921 5.57795 21.5 5.98535V11.25C21.5 11.6593 21.172 11.9921 20.7646 12H15.5C15.0858 12 14.75 11.6642 14.75 11.25C14.75 10.8407 15.078 10.5079 15.4854 10.5H18.9395L13.0303 4.59082C12.8896 4.45024 12.6989 4.37109 12.5 4.37109C12.3075 4.37109 12.1227 4.44579 11.9834 4.57812L11.9697 4.59082L9.59082 6.96973C9.16888 7.39161 8.59669 7.62891 8 7.62891C7.41265 7.62891 6.84859 7.39878 6.42871 6.98926L0.719727 1.28027C0.426833 0.98738 0.426833 0.51262 0.719727 0.219727Z"
        fill="#E58B03"
      />
    </Icon>
  );
};
